/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {GenericDrivenEntity} from '../entity/generic-driven-entity';

export class DataGroup {
  idField: string;
  labelField: string;
  itemsField: string;

  constructor(idField?: string, labelField?: string, itemsField?: string) {
    this.idField = idField ? idField : 'id';
    this.labelField = labelField ? labelField : 'label';
    this.itemsField =  itemsField ? itemsField : 'items';
      // Init array
    this[this.itemsField] = [];
  }

  getId(): string {
    return this[this.idField];
  }

  getLabel(): string {
    return this[this.labelField];
  }

  getItems(): GenericDrivenEntity[] {
    return this[this.itemsField];
  }

  pushItem(item: GenericDrivenEntity) {
    this[this.itemsField].push(item);
  }

  getFirstItem() {
    if (this[this.itemsField]) {
      return this[this.itemsField][0];
    }
    console.error('this.' + this.itemsField + ' undefined');
    return null;
  }
}
